{
  "meta": {
    "title": "Legal notice | Khromatik",
    "description": "Legal notice, privacy, and company information for Khromatik Digital S.R.L."
  },
  "heading": {
    "main": "Legal notice"
  },
  "legalBasis": "Service provider information pursuant to applicable law.",
  "company": {
    "name": "KHROMATIK DIGITAL S.R.L.",
    "address": "Str. Armoniei, nr. 23A, ap. B1\nTimișoara, Romania",
    "regLabel": "Trade register no. (ONRC):",
    "regValue": "J2026019403001",
    "cuiLabel": "Unique identification code (CUI):",
    "cuiValue": "54324200"
  },
  "contact": {
    "heading": "Contact:",
    "emailLabel": "Email:"
  },
  "privacy": {
    "title": "Privacy policy",
    "leadTitle": "Privacy",
    "lead": "We take the protection of your personal data seriously. We process personal data in accordance with applicable data protection law and this privacy policy.",
    "controllerTitle": "Controller",
    "controllerAddress": "KHROMATIK DIGITAL S.R.L.\nStr. Armoniei, nr. 23A, ap. B1\nTimișoara, Romania",
    "accessDataTitle": "Server log data",
    "accessDataIntro": "When you visit this website, the hosting provider automatically collects technical access information (server log files), including:",
    "accessDataList": {
      "i1": "Page visited",
      "i2": "Time of access",
      "i3": "Amount of data transferred",
      "i4": "Referrer/source used to reach the page",
      "i5": "Browser type",
      "i6": "Operating system",
      "i7": "IP address (typically shortened or anonymised by the host)"
    },
    "accessDataOutro": "This data is used for security, troubleshooting, and statistical purposes. We may review logs if there are concrete indications of unlawful use.",
    "cookiesTitle": "Cookies",
    "cookiesP1": "This site uses technically necessary browser storage (e.g. localStorage) for your language choice and your cookie consent. If you agree, Google Analytics and Microsoft Clarity may use cookies or similar technologies. You can give or withdraw consent via the banner on first visit or anytime via “Cookie settings” in the footer. Without consent, those analytics tools are not loaded.",
    "cookiesP2": "Embedded content (e.g. Vimeo videos) may set third-party cookies; we do not control that. You can restrict or delete cookies in your browser settings.",
    "rightsTitle": "Your rights",
    "rightsP1": "Depending on applicable law, you may have the right to access, rectify, erase, restrict processing, object, and data portability regarding your personal data.",
    "rightsP2": "If you have questions about privacy, contact us using the details above."
  },
  "disclaimer": {
    "title": "Disclaimer",
    "contentTitle": "Liability for content",
    "contentP1": "We create the content of these pages with care. However, we cannot guarantee that content is complete, correct, or up to date. As a service provider we are responsible for our own content under general law; we are not obliged to monitor third-party information transmitted or stored without concrete indication of illegality.",
    "contentP2": "Obligations to remove or block unlawful content under general law remain unaffected. Liability is only possible from the time we become aware of a specific infringement. We will remove such content promptly upon notice.",
    "linksTitle": "Liability for links",
    "linksP1": "Our site contains links to external third-party websites. We have no influence over their content and accept no liability for it. The respective provider is always responsible for linked pages.",
    "linksP2": "Linked sites were checked for obvious violations when the link was created. Permanent monitoring without concrete evidence of a violation is not reasonable. We will remove links if we become aware of infringements."
  },
  "credits": {
    "title": "Image credits",
    "photosPrefix": "Photos from",
    "iconsPrefix": "Icons from"
  }
}
